import React, { cloneElement } from "react";
import {
  List,
  DateField,
  EmailField,
  TextField,
  Filter,
  ExportButton,
  TextInput,
  EditButton,
  CreateButton,
  TopToolbar,
  useListContext,
  BooleanField,
  BooleanInput,
  useRecordContext,
  useGetList,
  AutocompleteInput,
  ReferenceField,
  SelectColumnsButton,
  DatagridConfigurable,
  WrapperField,
} from "react-admin";

import { ImpersonateButton } from "./partials/ImpersonateButton";
import Chip from "@mui/material/Chip";

const UserFilter = (props) => {
  const { data: allRoles, isLoading } = useGetList("user/roles");
  const { data: allStates, isLoadingStates } = useGetList("geo/states");
  return (
    <Filter {...props}>
      <TextInput source="email" label="Search by email" alwaysOn name="email" />
      <TextInput
        source="athena_id"
        label="Search by Athena ID"
        name="athena_id"
        alwaysOn
      />
      <TextInput
        source="first_name"
        label="Search by first name"
        name="first_name"
      />
      <TextInput
        source="last_name"
        label="Search by last name"
        name="last_name"
      />
      <TextInput source="progyny_id" label="Progyny ID" name="progyny_id" />
      <TextInput
        source="athena_tablespace_id"
        label="Athena TS"
        name="athena_tablespace_id"
      />
      <BooleanInput source="self_pay" label="Self Pay" name="self_pay" />
      <AutocompleteInput
        source="roles"
        choices={allRoles}
        optionText="name"
        isLoading={isLoading}
        sx={{ minWidth: 239 }}
      />
      <AutocompleteInput
        source="state_id"
        choices={allStates}
        optionValue="id"
        isLoading={isLoadingStates}
        sx={{ minWidth: 239 }}
      />
    </Filter>
  );
};

const ListActions = (props) => {
  const { className, filters, maxResults } = props;
  const { sort, resource, displayedFilters, filterValues, showFilter, total } =
    useListContext();

  return (
    <TopToolbar className={className}>
      <SelectColumnsButton />
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <CreateButton />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={sort}
        filterValues={filterValues}
        maxResults={maxResults}
      />
    </TopToolbar>
  );
};

const RolesField = () => {
  const record = useRecordContext();
  return (
    <ul style={{ listStyle: "none", marginBottom: "2px" }}>
      {record.roles.map((item) => (
        <li key={item}>
          <Chip label={item} />
        </li>
      ))}
    </ul>
  );
};

export const UserList = () => {
  return (
    <List
      title="All users"
      sort={{ field: "created_at", order: "DESC" }}
      filters={<UserFilter />}
      actions={<ListActions />}
    >
      <DatagridConfigurable rowClick={false}>
        <TextField source="id" />
        <EmailField source="email" />
        <TextField source="first_name" label="First Name" />
        <TextField source="last_name" label="Last Name" />
        <RolesField label="Roles" />
        <ReferenceField source="state_id" reference="geo/states" link={false}>
          <TextField source="iso_code" />
        </ReferenceField>
        <TextField
          source="menopause_type"
          label="Menopause Type"
          sortable={false}
        />
        <BooleanField source="self_pay" label="Self Pay" sortable={true} />
        <TextField source="phone_number" label="Phone" sortable={true} />
        <TextField source="progyny_id" label="Progyny ID" sortable={true} />
        <TextField source="athena_id" label="Athena ID" sortable={true} />
        <TextField
          source="athena_tablespace_id"
          label="Tablespace ID"
          sortable={true}
        />
        <DateField source="last_login" label="Last Login" showTime={true} />
        <DateField source="created_at" label="Created" />
        <DateField source="updated_at" label="Updated" />
        <WrapperField label="Actions">
          <EditButton />
          <ImpersonateButton />
        </WrapperField>
      </DatagridConfigurable>
    </List>
  );
};
